import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  constructor() { }

  scrollEvent = new EventEmitter();

  scrollDetected() {
    this.scrollEvent.emit();
  }
}
